import React from "react";

export default function HowItWorksSubtitle({ children }) {
  return (
    <div className='how-it-works__subtitle'>
      <p>{children}</p>
    </div>
  );
}
